import { IonIcon } from "@ionic/react";
import {
  arrowDownSharp,
  arrowUpSharp,
  pricetagOutline,
  trashOutline,
} from "ionicons/icons";
import { useContext, useEffect, useState } from "react";
import { useOutletContext } from "react-router";
import styled, { css, keyframes } from "styled-components";
import { searchProductImages } from "../../services/ProductImageService";
import { copyProductPropertiesWithoutStyles } from "../../services/Utils";
import { Image } from "../sharable/EncarteProduct/EncarteProduct.styles";
import {
  findUnityByLabel,
  findUnityByValue,
  UNITYS_LABELS,
  CESTA_BASICA_KIT,
  FROM_X_TO_Y_PROMOTION,
  SIMPLE_PROMOTION,
  TAKE_X_PAY_Y_PROMOTION,
  VAREJO_ATACADO_PROMOTION,
} from "../WorkSpace/CanvasViewer/EncarteConstants";
import WorkspaceContext from "../WorkSpace/WorkspaceContext";
import Button from "./ActionButton";
import FormMessage from "./FormMessage";
import Loading from "./Loading";
import { Selector } from "./PickerAndSelector";
import RecommendedProductsSearch from "./RecommendedProductsSearch";
import UploadButton from "./UploadButton";
import WhatsAppAnimatedLink from "./WhatsAppAnimatedLink";
const OBS_MAX_LENGTH = 30;
const rotating = keyframes`
    to {
        transform: rotate(360deg);
    }
`;

export const BoxImage = styled.div`
  span {
    color: #fff !important;
  }
  position: relative;
  grid-column: 1/4;
  margin-top: 1.4rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  background-color: #fff;
  color: black;
  align-items: center;
  justify-content: center;
  height: min-content;
  width: 100%;
  .loading-currentProductImages {
    animation: ${rotating} 1s linear infinite;
    color: #d97706;
    grid-column: 1/-1;
    display: inline-block;
  }
  .button {
    grid-column: 1/-1;
  }
  padding: 1rem;
  ${({ imagesCount }) => {
    const gridColumns = imagesCount < 4 ? imagesCount : 4;
    if (imagesCount === 0) {
      return css`
        display: none;
      `;
    }
    return css`
      grid-template-columns: repeat(${gridColumns}, 1fr);
    `;
  }}
`;

const BoxImageControls = styled.div`
  grid-column: 1/-1;
  display: flex;
  justify-content: space-between;
  margin-top: 1.4rem;
  .next-button {
    grid-column: 2/3;
    margin-left: auto;
    button {
      width: min-content;
      margin: 0;
    }
  }
`;

const ProductRequestLinkRow = styled.div`
  grid-column: 1/-1;
  margin-top: 1.2rem;
  text-align: center;
  font-size: 1.3rem;
  line-height: 1.5;

  span {
    color: #111827 !important;
    margin-right: 0.4rem;
  }
`;

const ProductInput = styled.div`
  display: grid;
  grid-template-rows: min-content min-content;
  padding: 1.4rem 0;
  column-gap: 0;
  row-gap: 0;
  grid-template-columns: min-content 1fr 1fr;
  justify-content: center;
  justify-items: center;
  .buttons {
    margin-top: 1rem;
    grid-column: 1/4;
    width: calc(100% - 3px);
    justify-content: space-around;
  }
  & .name {
    grid-column: 2/4;
    grid-row: 2/3;
    align-self: start;
    width: 100%;
  }

  & .price {
    grid-column: 2/4;
    grid-row: 3/4;
    width: 100%;
  }

  .label {
    width: min-content;
    display: flex;
    background-color: #c0c0c0ff;
    align-items: center;
    justify-content: center;
    color: #020202ff;
    text-transform: capitalize;
    padding: 0.2rem 0.4rem;
    border-bottom: 1px solid #6b6b6bff;
  }

  .unity {
    grid-column: 3/4;
    grid-row: 4/5;
    width: 100%;
  }

  .quantity {
    grid-column: 2/4;
    grid-row: 5/6;
    width: 100%;
  }

  .obs {
    grid-column: 2/3;
    grid-row: 4/5;
    width: 100%;
    text-transform: none;
  }
  align-items: end;

  .icon {
    font-size: 1.8rem;
    transition: all 300ms easy-in-out;
  }

  .icon-wrapper {
    width: min-content;
    height: min-content;
    position: relative;
    cursor: pointer;
    gap: 0.6rem;
    padding: 0.2rem 0.4rem;
    margin-bottom: 1rem;
    align-self: end;
    grid-column: 3/4;
    span {
      font-size: 1rem;
      text-transform: capitalize;
      display: block;
    }
  }

  .icon-wrapper:hover {
    color: #dc2626;
  }
  .icon-wrapper:before {
    right: 0;
    top: 0;
    position: absolute;
    font-size: 1.2rem;
    transform: translate(120%, -20%);
    color: #fff;
    padding: 0.4rem 0.8rem;
    border-radius: 0px;
    opacity: 1;
  }

  .icon-wrapper:hover:before {
    opacity: 1;
  }
  .icon:hover {
  }

  .not-deleteable-message {
    grid-column: 1/3;
  }

  .remove-product {
  }
`;

const Input = styled.input`
  padding: 1.2rem 0 1.2rem 1rem;
  text-transform: capitalize;
  height: 3.4rem;
  accent-color: #d97706;

  input,
  select {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    -webkit-background-clip: text !important;
  }
`;

const ProductImagePreview = styled.div`
  background-color: #f7f7f7ff;
  width: 9rem;
  /* use explicit height prop when provided, fallback to 9rem */
  ${({ height }) => (height ? `height: ${height};` : `height: 9rem;`)}
  min-height: 10.6rem;
  grid-column: 1/2;
  grid-row: 2/5;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  -webkit-background-size: contain;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  position: relative;
  -webkit-transform: translateZ(0); /* force compositing on iOS/Safari */
  poisition: relative;
  ${({ url }) => {
    if (url && url !== "undefined" && url !== "")
      return css`
        background-image: url(${url});
        background-position: center center;
        background-size: contain;
        -webkit-background-size: contain;
      `;
    else {
      return css`
        background-image: url("images/no-image.png");
        background-size: 90%;
        -webkit-background-size: 90%;
        &:after {
          content: "nenhuma imagem selecionada";
          position: absolute;
          font-size: 0.9rem;
          width: 100%;
          color: #1a1919ff;
          bottom: 2px;
          left: 50%;
          transform: translateX(-50%);
          text-transform: uppercase;
          text-align: center;
          line-height: 1.2;
        }
      `;
    }
  }}
`;

const LabelInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  font-size: 1.4rem;
  position: relative;
  &.checkbox {
    flex-direction: row;
    justify-content: start;
    align-items: center;
  }
`;

const NoImagesMessage = styled.p`
  font-size: 1.2rem;
  text-align: center;
  grid-column: 1/3;
`;

const AdvancedOptionsButton = styled.div`
  cursor: pointer;
  transition: ease-in-out 200ms;
  display: flex;
  width: fit-content;
  grid-column: 1/4;
  margin-top: 1.4rem;
  padding: 0.8rem 1.2rem;
  border: 1px solid #d97706;
  border-radius: 8px;
  color: #d97706;
  span {
    font-size: 1.4rem;
    display: inline-block;
    text-align: center;
  }

  .promotion-badge {
    font-size: 1.1rem;
    padding: 0.1rem 0.8rem;
    border-radius: 999px;
    background-color: #d97706;
    color: #fff;
  }

  &&:hover {
    background-color: #d97706;
    color: #fff;
  }

  &&:hover .promotion-badge {
    background-color: #fff;
    color: #d97706;
  }

  .icon {
    font-size: 1.8rem;
  }
`;

const PROMOTION_LABELS = {
  [TAKE_X_PAY_Y_PROMOTION]: "Leve X Pague Y",
  [FROM_X_TO_Y_PROMOTION]: "De/Por",
  [VAREJO_ATACADO_PROMOTION]: "Atacado/Varejo",
};

const SwapControls = styled.div`
  .icon {
    cursor: pointer;
    transition: all ease-in-out 200ms;
  }
  .icon:hover {
    color: #d97706;
  }

  grid-column: 2/3;
  font-size: 1rem;
  margin-bottom: 1rem;
`;

export function ProductForm({
  wasNoImageFound,
  setNoImageFound,
  handleCurrentProductImageUpdate,
  setCurrentProductId,
  setCurrentProductName,
  setCurrentProductImages,
  currentProductId,
  currentProductName,
  prod,
  removeProduct,
  updateProductInfo,
  downloadingProductImage,
  productIndex,
  setShowAdvancedOptionsForCurrentProduct,
  showAdvancedOptionsForCurrentProduct,
  showImageButtons = true,
}) {
  const { token, user, isAccountPremium } = useOutletContext();

  const {
    productRefs,
    styles,
    products,
    swapProductPositions,
    onProductsChange,
  } = useContext(WorkspaceContext);
  const [resourceSearchResult, setResourceSearchResult] = useState(null);
  const [showNameError, setShowNameError] = useState(false);
  const [isNameFocused, setIsNameFocused] = useState(false);
  const [quantityInputValue, setQuantityInputValue] = useState(
    String(prod.quantity ?? 1),
  );

  const fetchProductImages = async ({
    productName,
    token,
    page,
    userEmail,
    setResourceSearchResult,
    setNoImageFound,
  }) => {
    setNoImageFound(false);
    if (
      !productName ||
      productName.length < 3 ||
      productName.toLowerCase().includes("nome do produto")
    )
      return;
    const resourceSearchResult = await searchProductImages(
      productName,
      token,
      page,
      userEmail,
    );
    setResourceSearchResult(resourceSearchResult);
    if (resourceSearchResult.resources.length <= 0) setNoImageFound(true);
  };
  /**
   * Callback for registered producsts onClick
   * @param {*} product
   */
  const handleRegisteredProductClick = (product) => {
    const productsCopy = [...products];
    const p1 = { ...productsCopy[productIndex] };
    productsCopy[productIndex] = copyProductPropertiesWithoutStyles(
      product,
      p1,
    );
    onProductsChange(productsCopy);
    setIsNameFocused(false);
  };
  return (
    <ProductInput
      ref={(el) => (productRefs.current[productIndex] = el)}
      onChange={() => {
        setCurrentProductName(prod.name);
      }}
      onClick={(e) => {
        if (currentProductId != productIndex || currentProductName != prod.name)
          setCurrentProductImages([]);
        setCurrentProductId(productIndex);
        setCurrentProductName(prod.name);
      }}
      data-product-id={productIndex}
      className="product"
      key={`product-${productIndex}`}
    >
      {products.length > 1 && (
        <SwapControls className="flex min-gap align">
          {productIndex !== 0 && (
            <IonIcon
              icon={arrowUpSharp}
              className="icon"
              onClick={() =>
                swapProductPositions(productIndex, productIndex - 1)
              }
            />
          )}
          {productIndex !== products.length - 1 && (
            <IonIcon
              icon={arrowDownSharp}
              className="icon"
              onClick={() =>
                swapProductPositions(productIndex, productIndex + 1)
              }
            />
          )}
          <span>Alterar posição</span>
        </SwapControls>
      )}
      {/*User should not be able to remove product when a grid was choose because it brakes the grid */}
      {removeProduct ? (
        <div
          className="icon-wrapper flex align remove-produdct"
          onClick={removeProduct}
        >
          <span>remover</span>
          <IonIcon icon={trashOutline} className="icon" />{" "}
        </div>
      ) : (
        ""
      )}
      <ProductImagePreview
        url={`${prod.displayUrl}`}
        height="9rem"
        hover={true}
        key={`image-${prod.id}`}
        backgroundSize="contain"
      />
      <div className="name flex direction-column min-gap">
        <LabelInputWrapper className="name direction-row">
          <span className="label">Nome</span>
          <RecommendedProductsSearch
            isOpen={currentProductId === productIndex && isNameFocused}
            isAccountPremium={isAccountPremium}
            token={token}
            productName={prod.name}
            onSelectProduct={handleRegisteredProductClick}
          />
          <Input
            value={prod.name}
            className="name"
            type="text"
            placeholder="nome do produto"
            onFocus={() => setIsNameFocused(true)}
            onBlur={() => setIsNameFocused(false)}
            onKeyDown={(e) => {
              if (e.key === "Escape") setIsNameFocused(false);
            }}
            onInput={(e) => {
              setIsNameFocused(true);
              updateProductInfo(productIndex, "name", e.target.value);
              setCurrentProductName(e.target.value);
              setCurrentProductId(productIndex);
            }}
          />
        </LabelInputWrapper>
        {showNameError && (
          <FormMessage
            message={"Insira o nome do produto antes de carregar a imagem."}
            key={productIndex}
            backgroundColor="transparent"
            align="left"
          />
        )}
      </div>
      <LabelInputWrapper className="price direction-row">
        <span className="label">R$</span>
        <Input
          value={prod.promotionPrice}
          data="valor"
          placeholder="R$00,00"
          type="text"
          className="price"
          onInput={(e) => {
            const parsedPrice = parsePrice(e.target.value);
            if (parsedPrice)
              updateProductInfo(productIndex, "promotionPrice", parsedPrice);
          }}
        />
      </LabelInputWrapper>
      {styles.format === CESTA_BASICA_KIT && (
        <LabelInputWrapper className="quantity direction-row">
          <span className="label">Qtd</span>
          <Input
            value={quantityInputValue}
            type="number"
            min="1"
            className="quantity"
            onInput={(e) => {
              const raw = e.target.value;
              setQuantityInputValue(raw);
              const val = parseInt(raw, 10);
              if (!isNaN(val) && val > 0)
                updateProductInfo(productIndex, "quantity", val);
            }}
            onBlur={() => {
              // Reset to last valid value if field is empty or invalid on blur
              const val = parseInt(quantityInputValue, 10);
              if (isNaN(val) || val <= 0) {
                const fallback = prod.quantity ?? 1;
                setQuantityInputValue(String(fallback));
              }
            }}
          />
        </LabelInputWrapper>
      )}
      <LabelInputWrapper className="obs direction-row">
        <span className="label">Obs</span>
        <Input
          value={prod.obs ?? ""}
          type="text"
          className="obs"
          maxLength={OBS_MAX_LENGTH}
          placeholder="Ex: Vence em 3 dias"
          onInput={(e) =>
            updateProductInfo(
              productIndex,
              "obs",
              e.target.value.slice(0, OBS_MAX_LENGTH),
            )
          }
        />
      </LabelInputWrapper>
      <LabelInputWrapper className="unity">
        <Selector
          data="unidade"
          className="unidade"
          options={UNITYS_LABELS}
          callback={(label) => {
            updateProductInfo(
              productIndex,
              "measurement",
              findUnityByLabel(label).value,
            );
          }}
          selected={findUnityByValue(prod.measurement)?.label}
        />
      </LabelInputWrapper>

      {setShowAdvancedOptionsForCurrentProduct && (
        <AdvancedOptionsButton
          className="flex align min-gap justify"
          onClick={() => {
            setShowAdvancedOptionsForCurrentProduct(
              !showAdvancedOptionsForCurrentProduct,
            );
          }}
        >
          <IonIcon icon={pricetagOutline} className="icon" />
          <span>
            {PROMOTION_LABELS[prod.promotionType]
              ? "Editar promoção"
              : "Adicionar promoção"}
          </span>
          {PROMOTION_LABELS[prod.promotionType] && (
            <span className="promotion-badge">
              {PROMOTION_LABELS[prod.promotionType]}
            </span>
          )}
        </AdvancedOptionsButton>
      )}

      {currentProductId === productIndex && (
        <BoxImage
          className="box"
          imagesCount={resourceSearchResult?.resources.length || 0}
        >
          {currentProductId === productIndex &&
            resourceSearchResult?.resources.length > 0 &&
            downloadingProductImage && (
              <Loading color="#fff" $NoBgColor txt={"Baixando imagem..."} />
            )}
          {resourceSearchResult &&
            resourceSearchResult?.resources.map((image, id) => (
              <Image
                onClick={() => {
                  handleCurrentProductImageUpdate(image);
                }}
                url={`${image.displayUrl}`}
                height="9rem"
                hover={true}
                key={`image-${id}`}
                backgroundSize="contain"
              />
            ))}
          <BoxImageControls>
            {resourceSearchResult?.isExactMatch &&
              resourceSearchResult?.currentPage > 0 && (
                <div className="">
                  <Button
                    action={async () => {
                      await fetchProductImages({
                        productName: prod.name,
                        token,
                        page: resourceSearchResult.currentPage - 1,
                        userEmail: user.email,
                        setResourceSearchResult,
                        setNoImageFound,
                      });
                    }}
                    text={"Anterior"}
                    size={"1"}
                    $NoBgColor
                  />
                </div>
              )}
            {resourceSearchResult?.isExactMatch &&
              resourceSearchResult?.hasNextPage && (
                <div className="next-button">
                  <Button
                    action={async () => {
                      await fetchProductImages({
                        productName: prod.name,
                        token,
                        page: resourceSearchResult.currentPage + 1,
                        userEmail: user.email,
                        setResourceSearchResult,
                        setNoImageFound,
                      });
                    }}
                    text={"Próximo"}
                    $NoBgColor
                    size={"1"}
                  />
                </div>
              )}
          </BoxImageControls>
          {resourceSearchResult?.resources.length > 0 && (
            <ProductRequestLinkRow>
              <span>Não encontrou seu produto?</span>
              <WhatsAppAnimatedLink
                email={user.email}
                messageContent={`Não encontrei o cadastro do produto \"${currentProductName}\" e gostaria de solicitá-lo.`}
              >
                solicite o cadastro
              </WhatsAppAnimatedLink>
            </ProductRequestLinkRow>
          )}
        </BoxImage>
      )}
      <NoImagesMessage>
        {wasNoImageFound &&
          `Nenhuma imagem foi encontrada para o produto "${currentProductName}"`}
      </NoImagesMessage>

      {showImageButtons && (
        <div className="buttons flex align-between">
          <Button
            color={"#fff"}
            size="1.4"
            text={"Buscar imagens"}
            action={async () => {
              // Uses prod.name: the wrapper's onClick updates the "current" state only after this handler runs.
              await fetchProductImages({
                productName: prod.name,
                token,
                page: 0,
                userEmail: user.email,
                setResourceSearchResult,
                setNoImageFound,
              });
            }}
          />
          <UploadButton
            size="1.4"
            text={"Carregar da galeria"}
            $NoBgColor
            productName={prod.name}
            perform={(productImage) => {
              updateProductInfo(
                productIndex,
                "displayUrl",
                productImage.displayUrl,
              );
              updateProductInfo(productIndex, "imageURL", productImage.url);
            }}
            beforeUpload={() => {
              // Validate name before upload
              setShowNameError(false);
              const isPlaceholder = prod.name
                .trim()
                .toLowerCase()
                .includes("nome do produto");
              if (
                prod.name.trim() === "" ||
                prod.name.length < 3 ||
                isPlaceholder
              ) {
                setShowNameError(true);
                return false; // Prevent upload
              }
              return true;
            }}
          />
        </div>
      )}
    </ProductInput>
  );
}

export const parsePrice = (price) => {
  //strip comma
  price = price.split(",").join("");
  console.log(price, typeof price);
  const digitRegex = RegExp("^\\d+$");
  const zeroRegex = RegExp("^0+$");
  if (!price || price.length == 0 || !digitRegex.test(price)) return;
  const digitCount = price.length;
  let parsedPrice = ``;
  if (digitCount >= 3) {
    const cents = price.slice(digitCount - 2);
    let real = price.slice(0, digitCount - 2);
    if (zeroRegex.test(real)) {
      real = "0";
    } else if (real[0] === "0") {
      real = real.slice(1);
    }
    parsedPrice = `${real},${cents}`;
  } else if (digitCount == 2) {
    parsedPrice = `0,${price}`;
  } else if (digitCount == 1) {
    parsedPrice = `0,0${price}`;
  }

  return parsedPrice;
};
